import { Nav } from "react-bootstrap";
import { SidebarOption } from "./SidebarOption";
import VerticalFoldingMenuItem from "./VerticalFoldingMenuItem";

interface VerticalFoldingMenuProps {
  options: SidebarOption[];
  url: string;
  onSelect: (url: string) => void;
}

const VerticalFoldingMenu = ({
  options,
  url,
  onSelect,
}: VerticalFoldingMenuProps) => {
  return (
    <Nav className="flex-column px-1 w-100">
      {options.map((option, index) => (
        <VerticalFoldingMenuItem
          key={index}
          option={option}
          url={url}
          onSelect={onSelect}
        />
      ))}
    </Nav>
  );
};

export default VerticalFoldingMenu;
